import React from "react";
import { Container, Typography, Box } from "@mui/material";

const FAQ = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4, mt: 20 }}>
      <Typography
        variant="h3"
        component="h1"
        align="center"
        gutterBottom
        sx={{ fontWeight: 100, mt: 5, mb: 10 }}
      >
        Frequently Asked Questions
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Can I order online and pick up in store?
        </Typography>
        <Typography color="text.secondary">
          Yes, you'll have the option to select pick up in store during
          checkout. We will email or WhatsApp you when your order is ready for
          pick up. Please allow up to 2 business days for us to process your
          order. If you’d like same-day pick up, leave a note or contact us at
          contact@daina.com.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Where do you ship?
        </Typography>
        <Typography color="text.secondary">
          We currently ship across India, including metro cities, towns, and
          remote areas covered by major courier services.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          How much is shipping and when can I expect my order to arrive?
        </Typography>
        <Typography color="text.secondary">
          We offer free standard shipping on all orders over ₹999 across India.
          Orders are usually shipped within 1–2 business days.
          <br />
          <br />
          <strong>Estimated Delivery Timeline:</strong>
          <br />
          Metro Cities: 2–4 Business Days
          <br />
          Tier 2 & 3 Cities: 4–6 Business Days
          <br />
          Remote Areas: 5–8 Business Days
          <br />
          <br />
          You will receive tracking details via email or WhatsApp once your
          order ships. Delivery delays may occur during festivals, national
          holidays, or due to local courier constraints.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Who do you ship with?
        </Typography>
        <Typography color="text.secondary">
          We primarily ship via Delhivery, Blue Dart, Ekart, and India Post.
          Shipping partners are selected based on your pincode for faster
          delivery. If you refuse delivery, shipping charges (if any) will be
          deducted from your refund.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Taxes & GST
        </Typography>
        <Typography color="text.secondary">
          All prices listed on our website are inclusive of applicable GST. You
          will receive a GST invoice along with your order. For bulk orders or
          B2B inquiries, please email us at contact@daina.com.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 400 }}>
          Shipping on Exchanges within India
        </Typography>
        <Typography color="text.secondary">
          If you need to exchange your product for a different size or color and
          your order qualifies for free shipping (₹999+), we’ll provide a
          one-time reverse pickup and free reship.
          <br />
          <br />
          If your order was below ₹999 or part of a discounted deal, return
          shipping will be borne by the customer.
        </Typography>
      </Box>
    </Container>
  );
};

export default FAQ;
